// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  // apiKey: "AIzaSyDXLD5Pdcafw1hgOu8GQU6lqFl3pTRz9e8",
  // authDomain: "campus-selection-34777.firebaseapp.com",
  // databaseURL: "https://campus-selection-5f487.firebaseio.com",
  // projectId: "campus-selection-34777",
  // storageBucket: "campus-selection-34777.appspot.com",
  // messagingSenderId: "1014612256089",
  // appId: "1:1014612256089:web:6f048d031ea5de63851848",
  // measurementId: "G-HH503WSWQE"
  apiKey: "AIzaSyAvIKy4SV-4F5S4M4ePRXu1K6dzRJTe-yM",
  authDomain: "campus-selection-26d6b.firebaseapp.com",
  databaseURL: "https://campus-selection-26d6b.firebaseio.com",
  projectId: "campus-selection-26d6b",
  storageBucket: "campus-selection-26d6b.appspot.com",
  messagingSenderId: "307353504273",
  appId: "1:307353504273:web:8e56974d9a6a96c65e3fb0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
export { auth, db, storage };
